import { Typeahead } from "@EMOrg-prd/react-standard";
import { Item } from "../models/General";
import { useMemo } from "react";

interface Props {
  label: string;
  placeholder: string;
  items: Item[];
  value: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  clearable?: boolean;
  itemTemplate?: (item: Item) => JSX.Element;
}

const TypeaheadField = ({
  label,
  placeholder,
  items,
  value,
  disabled = false,
  clearable = false,
  onChange,
  itemTemplate,
}: Props) => {
  const dropdownItems = useMemo(() => {
    return items
      .filter((item) =>
        item.name.toLowerCase().includes(value.trim().toLowerCase())
      )
      .map((item) => (
        <Typeahead.Item
          key={item.value}
          value={item.value}
          style={{
            cursor: "pointer",
          }}
        >
          <Typeahead.Item.Suggestion>
            {itemTemplate ? (
              itemTemplate(item)
            ) : (
              <>
                <strong>{item.name}</strong>
                <span> ({item.value})</span>
                {item.description && (
                  <span className="text-muted">
                    <br></br>
                    {item.description}
                  </span>
                )}
              </>
            )}
          </Typeahead.Item.Suggestion>
        </Typeahead.Item>
      ));
  }, [items, value, itemTemplate]);

  const note = useMemo(() => {
    try {
      const item = items.filter((item) => item.value === value)[0];
      return (
        <>
          {item.name}{" "}
          {item.description && (
            <>
              <br></br>
              <span className="text-muted">{item.description}</span>
            </>
          )}
        </>
      );
    } catch {
      return " ";
    }
  }, [items, value]);

  const fieldLabel = useMemo(() => {
    if (clearable) {
      return (
        <label className="em-c-field__label">
          {label}
          <span
            style={{
              fontFamily: "EMPrintLight",
              paddingLeft: "0.5em",
              paddingRight: "0.5em",
            }}
          >
            |
          </span>
          <span
            style={{
              textTransform: "uppercase",
              fontSize: "0.8em",
            }}
            className="text-button danger"
            onClick={() => onChange("")}
          >
            Clear
          </span>
        </label>
      );
    }

    return <label className="em-c-field__label">{label}</label>;
  }, [label, clearable, onChange]);

  return (
    <Typeahead
      onChange={(_, value) => {
        onChange(value);
      }}
      inputProps={{
        onChange: (e) => {
          onChange(e.target.value);
        },
        value,
        placeholder,
        disabled,
      }}
      fieldProps={{
        label: fieldLabel,
        note,
      }}
      style={{
        marginBottom: "1em",
      }}
      className="field-note-full-width"
    >
      {dropdownItems}
    </Typeahead>
  );
};

export default TypeaheadField;
